/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLocationComboRequest
 */
export interface UpdateLocationComboRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationComboRequest
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the UpdateLocationComboRequest interface.
 */
export function instanceOfUpdateLocationComboRequest(value: object): value is UpdateLocationComboRequest {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdateLocationComboRequestFromJSON(json: any): UpdateLocationComboRequest {
    return UpdateLocationComboRequestFromJSONTyped(json, false);
}

export function UpdateLocationComboRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationComboRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function UpdateLocationComboRequestToJSON(json: any): UpdateLocationComboRequest {
    return UpdateLocationComboRequestToJSONTyped(json, false);
}

export function UpdateLocationComboRequestToJSONTyped(value?: UpdateLocationComboRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

